import { gql } from "@apollo/client";

export default gql`
  query getAllOrganizationTeamsQuery($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      teams(orderBy: "title") {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;
